// Supported payment card brands (allowlist).
// Values match card-validator's `card.type` strings.
// ponytail: plain array config — add a brand here to support it, no code changes.
export const SUPPORTED_CARD_BRANDS = ['visa', 'mastercard'] as const

/** True if the detected card brand is accepted. Null/unknown brand → false. */
export const isSupportedCardBrand = (cardType: string | null | undefined): boolean =>
    !!cardType && (SUPPORTED_CARD_BRANDS as readonly string[]).includes(cardType)
